import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout from '../components/LegalLayout';

const TermsOfUse: React.FC = () => (
  <LegalLayout title="Termini di Servizio" lastUpdated="17 giugno 2026">
    <p>
      I presenti Termini di Servizio («Termini») disciplinano l'accesso e l'utilizzo del sito ChatLy
      (il «Sito») e dell'assistente conversazionale ChatLy su WhatsApp (il «Servizio»). Ti invitiamo a
      leggerli con attenzione: utilizzando il Sito o il Servizio dichiari di accettarli integralmente.
    </p>

    <h2>1. Titolare e contatti</h2>
    <p>
      Il Sito e il Servizio sono forniti da <strong>Alessio Di Como – Delta Code</strong>, Via di
      Sant'Alessio 39, 51100 Pistoia (PT), Italia — P.IVA 02138520479, email{' '}
      <a href="mailto:info@chatly.it">info@chatly.it</a> (il «Titolare»).
    </p>

    <h2>2. Oggetto del Servizio</h2>
    <p>
      Il Sito ha finalità informative e promozionali relative alla piattaforma ChatLy per
      l'automazione delle conversazioni WhatsApp. Il Servizio consente di interagire con un assistente
      basato su intelligenza artificiale. Il Sito e il Servizio sono forniti «così come sono» («as
      is») e «come disponibili», senza garanzie di disponibilità continuativa, assenza di errori o
      idoneità a uno scopo specifico.
    </p>

    <h2>3. Uso consentito</h2>
    <p>
      L'utente si impegna a utilizzare il Sito e il Servizio nel rispetto della legge e dei presenti
      Termini. È in particolare vietato inviare contenuti illeciti, diffamatori, molesti o lesivi di
      diritti altrui, nonché interferire con il corretto funzionamento dei sistemi.
    </p>

    <h2>4. Interazioni con l'intelligenza artificiale</h2>
    <p>
      Le risposte generate dall'assistente AI hanno carattere meramente informativo e possono
      contenere imprecisioni; non costituiscono consulenza professionale (legale, fiscale, medica o di
      altro tipo). L'utente è tenuto a verificare le informazioni prima di assumere decisioni. Il
      Titolare non risponde delle decisioni assunte sulla base delle risposte fornite dal bot.
    </p>

    <h2>5. Proprietà intellettuale</h2>
    <p>
      Il Sito, il Servizio e i relativi contenuti (testi, grafica, loghi, marchi, codice e
      funzionalità) sono di proprietà del Titolare o dei rispettivi licenzianti e sono protetti dalla
      normativa applicabile. È vietata la riproduzione, distribuzione o modifica, anche parziale,
      senza previa autorizzazione scritta, salvo l'uso personale e non commerciale consentito.
    </p>

    <h2>6. Limitazione di responsabilità</h2>
    <p>
      Nei limiti consentiti dalla legge, il Titolare non è responsabile per danni indiretti,
      incidentali o consequenziali, né per la perdita di dati, profitti o opportunità derivanti
      dall'accesso o dall'utilizzo (o dall'impossibilità di utilizzo) del Sito o del Servizio, da
      interruzioni o malfunzionamenti tecnici, o da contenuti e servizi di terze parti. Nulla nei
      presenti Termini esclude o limita la responsabilità nei casi in cui ciò non sia consentito dalla
      legge (es. dolo o colpa grave).
    </p>

    <h2>7. Manleva</h2>
    <p>
      L'utente si impegna a tenere indenne il Titolare da ogni pretesa, danno o spesa (incluse le
      spese legali) derivanti dall'uso improprio del Sito o del Servizio, dalla violazione dei
      presenti Termini o dei diritti di terzi.
    </p>

    <h2>8. Link e servizi di terze parti</h2>
    <p>
      Il Sito rinvia a servizi di terzi (in particolare WhatsApp/Meta). Il Titolare non controlla né è
      responsabile dei contenuti, delle policy o delle pratiche di tali soggetti, ai cui termini e
      informative l'utente è soggetto.
    </p>

    <h2>9. Trattamento dei dati personali</h2>
    <p>
      Il trattamento dei dati personali è descritto nell'<Link to="/privacy">Informativa sulla
      Privacy</Link> e nella <Link to="/cookie-policy">Cookie Policy</Link>.
    </p>

    <h2>10. Modifiche ai Termini e al Servizio</h2>
    <p>
      Il Titolare può modificare i presenti Termini o sospendere e interrompere il Servizio, in tutto
      o in parte, in qualsiasi momento. Le modifiche hanno effetto dalla pubblicazione su questa
      pagina; l'uso continuato del Servizio dopo tale pubblicazione costituisce accettazione delle
      modifiche.
    </p>

    <h2>11. Legge applicabile e foro competente</h2>
    <p>
      I presenti Termini sono regolati dalla legge italiana. Per i rapporti con utenti qualificabili
      come consumatori ai sensi del D.lgs. 206/2005 (Codice del Consumo) è competente, in via
      inderogabile, il foro del luogo di residenza o domicilio del consumatore; in ogni altro caso è
      competente in via esclusiva il Foro di Pistoia.
    </p>

    <h2>12. Disposizioni finali</h2>
    <p>
      L'eventuale invalidità o inefficacia di una clausola non pregiudica la validità delle restanti
      disposizioni. Il mancato esercizio di un diritto da parte del Titolare non costituisce rinuncia
      allo stesso. Per qualsiasi domanda sui presenti Termini è possibile scrivere a{' '}
      <a href="mailto:info@chatly.it">info@chatly.it</a>.
    </p>
  </LegalLayout>
);

export default TermsOfUse;
